import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { getMarketingConsent } from './services/consent/consentManager';
import { enableMetaPixel } from './services/metaPixel/metaPixelLoader';
// Self-hosted Font Awesome (bundled by Vite, fonts emitted to /assets) — replaces
// the cdnjs CDN <link> so icons load from our origin (faster, private, no SPOF).
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
// Bootstrap Meta Pixel early if user previously granted marketing consent
if (getMarketingConsent()) {
    enableMetaPixel().catch((err) => {
        console.error('[MetaPixel] Bootstrap failed:', err);
    });
}
// Initialize analytics asynchronously
const trackingId = import.meta.env['VITE_GA_TRACKING_ID'];
const analyticsEnabled = import.meta.env['VITE_ANALYTICS_ENABLED'] !== 'false';
const debugMode = import.meta.env['VITE_ANALYTICS_DEBUG'] === 'true';
console.log('[Analytics] Config:', { trackingId, analyticsEnabled, debugMode });
if (trackingId && analyticsEnabled) {
    import('./services/analytics')
        .then(({ initializeAnalytics }) => {
        return initializeAnalytics({
            trackingId,
            enabled: analyticsEnabled,
            debugMode,
            respectDNT: true,
        });
    })
        .then(() => {
    })
        .catch((err) => {
        console.error('[Analytics] Initialization failed:', err);
    });
}
else {
}
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>);
